import { useEffect } from "react";
import { useRouteLoaderData } from "react-router";
import { useTheme } from "remix-themes";
import { Toaster as Sonner, toast as notify } from "sonner";
import type { loader } from "~/root";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// WIP: This is a work in progress. This is not a final implementation.
export function ToastProvider(props: ToasterProps) {
  const [theme] = useTheme();
  const data = useRouteLoaderData<typeof loader>("root");

  useEffect(() => {
    const toast = data?.toast;
    if (!toast) return;
    notify[toast.type ?? "info"](toast.message, { id: toast.id, description: toast.description });
  }, [data?.toast]);

  return (
    <Sonner
      theme={theme ?? ("system" as ToasterProps["theme"])}
      className="select-none"
      position="top-right"
      richColors
      toastOptions={{
        classNames: {
          toast:
            "toast bg-background text-foreground border-default-400 shadow-medium rounded-large hover:border-default",
          description: "text-foreground-500",
        },
      }}
      closeButton={true}
      {...props}
    />
  );
}
